<template>
  <div class="sticker-chat-content">
    <img
      v-for="(item, indexFile) in messageFiles"
      :key="indexFile"
      class="sticker-chat-content__img cursor-pointer"
      :src="stickerSrc(item)"
      alt=""
      loading="lazy"
      decoding="async"
      @click="showFileSlideShow(messageFiles, indexFile)"
      @error="onStickerImageError($event, item)"
    >
    <div class="content-display-timestamp mt-5px mr-10px"
         v-if="!isMessageInBlock && !hideFooter">
      <span>{{ messageTime }}</span>
    </div>
  </div>
</template>

<script>
import { helpers } from "../../../../../helper/helpers";
import {
  resolveChatMediaDisplaySrc,
  fallbackChatMediaImageOnError,
} from "../../../../../helper/chatMediaDisplay";

export default {
  name: "sticker-chat-content",
  props: {
    currentMess: {
      type: Object,
      default: () => ({}),
    },
    nextMess: {
      type: Object,
      default: null,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    messageFiles() {
      const files = this.currentMess && this.currentMess.files;
      return Array.isArray(files) ? files : [];
    },
    messageTime() {
      return helpers.getMessageTime(this.currentMess);
    },
    isMessageInBlock() {
      return helpers.checkMessageInBlock(this.currentMess, this.nextMess);
    },
  },
  methods: {
    stickerSrc(item) {
      return resolveChatMediaDisplaySrc(item, { preferDirectPath: true });
    },
    onStickerImageError(event, item) {
      fallbackChatMediaImageOnError(event, item);
    },
    showFileSlideShow(files, index) {
      this.$modal.show("slide-show-modal", { items: files, activeId: index });
    },
  },
};
</script>

<style lang="scss">
.sticker-chat-content {
  display: inline-block;
  max-width: 120px;

  &__img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    border: 0 !important;
    display: block;
    background: transparent;
  }
}
</style>
